import { spaceTextByUpperCase } from '@eneco/common/string';

const PRESERVE_WORDS = ['RealtimeThuis'];

export function spaceConditionText(text: string): string {
  const spaced = spaceTextByUpperCase(text);

  return PRESERVE_WORDS.reduce((result, word) => {
    const spacedWord = spaceTextByUpperCase(word);
    return result.split(spacedWord).join(word);
  }, spaced);
}
